import React, { useState, useEffect } from 'react';

//components
import { Video, VideoProps } from 'src/components/common/modules/video-player/video';
import Figure, { FigureProps } from 'src/components/common/ui/figure/figure';
import VideoDetails from 'src/components/common/modules/video/videoJSPlayer/video-detail';
import { Typo } from 'src/components/common/ui';

//helpers
import { checkValue } from 'src/components/common/helper';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
import { getDeviceImage } from 'src/components/common/theme/component';

//types
import { articleProps } from '../typings';

interface RenderImageVideoComponentProps {
  article: articleProps;
  siteData: any;
  moduleStyle: string;
}

export const useRenderImageVideoComponent = (props: RenderImageVideoComponentProps) => {
  const {
    article,
    siteData: { id: siteId, templateType, campaignUrl },
    moduleStyle,
  } = props;
  const { width: windowWidth } = useWindowDimensions();
  const [isVideoPlay, setIsVideoPlay] = useState(false);
  const [images, setImages] = useState({ image: '', videoCover: '' });

  //set reposive image
  useEffect(() => {
    let device = 'desktop';
    if (windowWidth > 992) {
      device = 'desktop';
    } else if (windowWidth > 575) {
      device = 'tablet';
    } else {
      device = 'mobile';
    }
    setImages({
      image: getDeviceImage(article?.image, device, true),
      videoCover: getDeviceImage(article?.videoCoverImage, device, true),
    });
  }, [article, windowWidth]);

  const figureProps: FigureProps = {
    src: images?.image,
    exClass: 'lozad lozad  v2-featured-article-image',
    alt: 'Featured article image',
    roundcorner: false,
  };

  const videoProps: VideoProps = {
    src: article?.videoFilePath || article?.video?.[0]?.url,
    exClass: 'v2-featured-article-video',
    autoPlay: false,
    muted: true,
    loop: true,
    playsInline: true,
    heroScrollDownArrow: true,
    hideSoundControlsForVideo: false,
    isAutoPlayWhenInViewport: true,
    poster: images?.videoCover,
    hideVideoPlayControls: article?.hideVideoPlayControls,
  };

  const onVideoPlay = () => setIsVideoPlay(true);

  const videJsPorps = {
    key: 'featured-article-videojs',
    videoFile: article?.video,
    youtubeId: false,
    staticImage: article?.videoCoverImage,
    copyrightText: '',
    device: '',
    siteid: siteId,
    campaignUrl: campaignUrl,
    template: templateType,
    autoplay: false,
    exClassVideo: 'featured-article-video-js',
    onPlayVideo: () => onVideoPlay(),
    videoFilePath: article?.videoFilePath
  };

  const renderHtml = () => {
    if (moduleStyle === 'Brand video' && (checkValue(article?.video?.[0]?.url) || checkValue(article?.videoFilePath))) {
      return (
        <>
          <VideoDetails {...videJsPorps} />
          {!isVideoPlay && checkValue(article?.videoTitle) && (
            <Typo.HTMLText exClass="v2-featured-article-video-title override-heading-font-family" tag="p">
              {article?.videoTitle}
            </Typo.HTMLText>
          )}
        </>
      );
    } else if (checkValue(article?.video?.[0]?.url) || checkValue(article?.videoFilePath)) {
      return <Video {...videoProps} />;
    } else {
      return <Figure {...figureProps} />;
    }
  };

  return { renderHtml, images };
};
